const all = ['customer-users'] as const;

const findAll = (take?: number, skip?: number) => [...all, take, skip];

const findAllOnClient = (
  clientId: string,
  take?: number,
  skip?: number,
  sort?: string,
  search?: string
) => [...all, 'on', clientId, take, skip, sort, search];

export const customerUserKeys = { all, findAll, findAllOnClient };
